
import { gsap } from 'gsap'

export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      esgActiveReportMobile: 0,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
    })
  },
  methods: {
    initAnimation() {
      document.querySelectorAll('.esg-report').forEach((report) => {
        const img = report.querySelector('.esg-report-img')
        const line = report.querySelector('.liner')
        const text = report.querySelector('.text')
        const icon = report.querySelector('.esg-report-data img')
        const subTitle = report.querySelector('.esg-report-data .subtitle')

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: report,
            start: 'top center',
          },
        })

        tl.from(img, { x: 50, opacity: 0, duration: 0.2 })
        tl.from(line, { xPercent: 500, duration: 0.2 })
        tl.from(subTitle, { alpha: 0, duration: 0.1 })
        tl.from(text, { alpha: 0, duration: 0.1 })
        tl.from(icon, { alpha: 0, duration: 0.1 })
      })
    },
    setActiveEsgReportMobile(reportNumber) {
      this.esgActiveReportMobile = reportNumber
    },
  },
}
